const doc = [({"da":({"js":({"admin":({"economy":({"dimensions":({"index":({"locked_dimensions":"Låste dimensioner"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;